import { useEffect, useState } from "react";
import SideBar from "../../components/AdminDashboard/SideBar";
import "../../styles/AdminDashboard/Scheduling.scss";
import moment from "moment";
import { getAvailableDates } from "../../apis/UserDashboard/dashboard";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { updateIotDate } from "../../apis/AdminDashboard/users";
import Search from "../../components/AdminDashboard/Search";
export default function Scheduling() {
  const auth = useSelector((state) => state.auth);

  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [availableDates, setAvailableDates] = useState([]);
  const [bookedDates, setBookedDates] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [scheduleType, setScheduleType] = useState("pending");
  const [filter, setFilter] = useState(false);
  const [yearSearch, setYearSearch] = useState(false);
  const [addConfirm, setAddConfirm] = useState(false);
  const [pendingActiveRequests, setPendingActiveRequests] = useState([]);
  const [pendingInactiveRequests, setPendingInactiveRequests] = useState([]);
  const [completedRequests, setCompletedRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ongoingLoading, setOngoingLoading] = useState(false);
  const [activeLoading, setActiveLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(false);
  const [years, setYears] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");

  const fetchDatesFromStorage = async () => {

    const response = await getAvailableDates(auth?.token)
    console.log('response getAvailableDates', response);
    if(response?.data?.statusCode === 200) {
      setAvailableDates(response?.data?.message[2] ? response?.data?.message[2]?.values: []);
      const temp1 =  response?.data?.message[3] ? response?.data?.message[3]?.values?.map((item) => item?.value) : [];
      const temp2 =  response?.data?.message[1] ? response?.data?.message[1]?.values?.map((item) => item?.value) : []
      const temp3 =  response?.data?.message[0] ? response?.data?.message[0]?.values?.map((item) => item?.value) : []
      setBookedDates([...temp1, ...temp2, ...temp3])
      setPendingActiveRequests(response?.data?.message[3] ? response?.data?.message[3]?.values : []);
      setPendingInactiveRequests(response?.data?.message[1] ? response?.data?.message[1]?.values : []);
      setCompletedRequests(response?.data?.message[0] ? response?.data?.message[0]?.values : []);
    }else {
      toast.error(response?.data?.message)
    }

    // Fetch data from backend or local storage and update state
    // Available dates
   

   

    // const events = [
    //   ...availableDates.map((date) => ({
    //     start: new Date(date),
    //     end: new Date(date),
    //     title: "Available",
    //     isAvailable: true,
    //   })),
    //   ...bookedDates.map((date) => ({
    //     start: new Date(date),
    //     end: new Date(date),
    //     title: "Booked",
    //     isAvailable: false,
    //   })),
    // ];

    // setEvents(events);
  };

  useEffect(() => {
    // Fetch available and booked dates from backend or local storage
    fetchDatesFromStorage();
  }, []);

  useEffect(() => {
    console.log('available dates', availableDates);
  }, [availableDates]);

  const renderCalendarGrid = () => {
    console.log(
      'currentYear', currentYear
    );
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const startDay = new Date(currentYear, currentMonth, 1).getDay();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    console.log("daysInMonth", daysInMonth);
    const rows = [];
    let currentDay = 1;

    console.log("perimiter", new Date().getMonth());
    console.log("perimiter", new Date().getFullYear());

    // Create the calendar grid
    for (let i = 0; i < 1; i++) {
      const days = [];

      for (let j = 0; j <= daysInMonth; j++) {
        if (currentDay > daysInMonth) {
          // Finish rendering the calendar grid
          break;
        } else {
          // Render the date cell
          const dateString = `${currentYear}-${String(
            currentMonth + 1
          ).padStart(2, "0")}-${String(currentDay).padStart(2, "0")}`;
          // console.log("availableDates", availableDates);
          const isAvailable = availableDates?.includes(dateString);
          const isBooked = bookedDates?.includes(dateString);
          const cellClassName = `calendar-cell${
            isAvailable ? " available" : ""
          }${isBooked ? " booked" : ""}`;
          const dayOfWeek = new Date(
            currentYear,
            currentMonth,
            currentDay
          ).getDay();

          days.push(
            <div className="scheduling-main__calendar-row__days">
              <div
                key={dateString}
                className={
                  dayOfWeek === 6 || dayOfWeek === 0 || bookedDates?.includes(dateString)
                    ? `inactive-date ${cellClassName}`
                    : availableDates?.includes(dateString)
                    ? `active-date ${cellClassName}`
                    : `available ${cellClassName}`
                }
                onClick={() => {
                  if (dayOfWeek !== 6 && dayOfWeek !== 0 && !bookedDates?.includes(dateString)) {
                    handleDateClick(dateString);
                  }
                }}
              >
                {currentDay}
              </div>
              <div
                className={
                  dayOfWeek === 6 || dayOfWeek === 0 || bookedDates?.includes(dateString)
                    ? `inactive-date ${cellClassName}`
                    : ""
                }
              >
                {dayOfWeek === 1
                  ? "Mon"
                  : dayOfWeek === 2
                  ? "Tue"
                  : dayOfWeek === 3
                  ? "Wed"
                  : dayOfWeek === 4
                  ? "Thu"
                  : dayOfWeek === 5
                  ? "Fri"
                  : dayOfWeek === 6
                  ? "Sat"
                  : "Sun"}
              </div>
            </div>
          );
          currentDay++;
        }
      }

      rows.push(
        <div key={`row-${i}`} className="scheduling-main__calendar-row">
          {days}
        </div>
      );
    }




    return (
      <div className="calendar-grid">
        <div className="scheduling-main__calendar-months">
          <div
            className={
              currentMonth === 0 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(0)}
          >
            January
          </div>
          <div
            className={
              currentMonth === 1 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(1)}
          >
            February
          </div>
          <div
            className={
              currentMonth === 2 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(2)}
          >
            March
          </div>
          <div
            className={
              currentMonth === 3 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(3)}
          >
            April
          </div>
          <div
            className={
              currentMonth === 4 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(4)}
          >
            May
          </div>
          <div
            className={
              currentMonth === 5 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(5)}
          >
            June
          </div>
          <div
            className={
              currentMonth === 6 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(6)}
          >
            July
          </div>
          <div
            className={
              currentMonth === 7 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(7)}
          >
            August
          </div>
          <div
            className={
              currentMonth === 8 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(8)}
          >
            September
          </div>
          <div
            className={
              currentMonth === 9 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(9)}
          >
            October
          </div>
          <div
            className={
              currentMonth === 10 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(10)}
          >
            November
          </div>
          <div
            className={
              currentMonth === 11 &&
              "scheduling-main__calendar-months__month-active"
            }
            onClick={() => setCurrentMonth(11)}
          >
            December
          </div>
        </div>
        {rows}
      </div>
    );
  };

  const handleDateClick = (date) => {
    if (availableDates.includes(date)) {
      const updatedDates = availableDates.filter(d => d !== date);
      setAvailableDates(updatedDates);
    } else {
      setAvailableDates([date, ...availableDates]);
    }
  };

  const handleScheduleDates = async () => {
    setLoading(true)
    const response = await updateIotDate("set_availability", availableDates, auth?.token) ;
    console.log('update', response);

    if(response?.data?.statusCode === 200) {
      toast.success("Dates added successfully")
      setAddConfirm(false)
    }else {
      toast.error(response?.data?.message)
    }
    setLoading(false)

  };
  const handleSetOngoing = async (date) => {
    setSelectedItem(date?.id)
    setOngoingLoading(true)
    const response = await updateIotDate("ongoing_installation", date?.value, auth?.token) ;
    console.log('update', response);

    if(response?.data?.statusCode === 200) {
      toast.success("Update successful")
      fetchDatesFromStorage();
    }else {
      toast.error(response?.data?.message)
    }
    setOngoingLoading(false)

  };
  const handleSetCompleted = async (date) => {
    setSelectedItem(date?.id)
    setActiveLoading(true);
    const response = await updateIotDate("installation_completed", date?.value, auth?.token) ;
    console.log('update', response);

    if(response?.data?.statusCode === 200) {
      toast.success("Update successful")
      fetchDatesFromStorage();
    }else {
      toast.error(response?.data?.message)
    }
    setActiveLoading(false)
  };

  function generateYearArray() {
    const yearCurrent = new Date().getFullYear();
    const tempyears = [];
  
    for (let i = 0; i <= 10; i++) {
      tempyears.push(yearCurrent + i);
    }
  
    setYears(tempyears)
  }

  useEffect(() => {
    generateYearArray();
  }, [])


  return (
    <div className="scheduling">
      <div className="sidebar_container">
        <SideBar />
      </div>
      <div className="scheduling-main">
        <Search />
        <div className="scheduling-main__title">Scheduling</div>
        <div className="scheduling-main__subtitle-group">

          <div>Available slots</div>
          <div>
            {addConfirm &&
             <div className="calendar-confirm">
              <div className="calendar-confirm-title">Are you sure?</div>
              <div className="calendar-confirm-subtitle">
              All selected date will be made available to <br /> users for IoT installation
              </div>
              <div className="calendar-confirm-button-group">
                <button onClick={() => setAddConfirm(false)}>Cancel</button>
                <button onClick={handleScheduleDates}>{loading? "Loading..." : "Confirm"}</button>
              </div>
            </div>}
            <button onClick={() => setAddConfirm(true)}>Add</button>
            <button >
              <div onClick={() => setYearSearch(!yearSearch)}>Year</div>
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.16536 6.49967L8.4987 9.83301L11.832 6.49967"
                  stroke="#98A2B3"
                  stroke-width="1.33333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              {yearSearch && 
            <div className="ndclist-modal">
              {/* <div className="ndclist-modal__search">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.18016 12.2002C6.1873 12.2002 5.21673 11.9057 4.3912 11.3541C3.56566 10.8025 2.92224 10.0185 2.54228 9.10123C2.16233 8.18394 2.06292 7.17459 2.25662 6.20081C2.45031 5.22702 2.92842 4.33254 3.63048 3.63048C4.33254 2.92842 5.22702 2.45031 6.20081 2.25662C7.17459 2.06292 8.18394 2.16233 9.10123 2.54228C10.0185 2.92224 10.8025 3.56566 11.3541 4.3912C11.9057 5.21673 12.2002 6.1873 12.2002 7.18016C12.2002 7.83939 12.0703 8.49218 11.818 9.10123C11.5658 9.71028 11.196 10.2637 10.7298 10.7298C10.2637 11.196 9.71028 11.5658 9.10123 11.818C8.49218 12.0703 7.83939 12.2002 7.18016 12.2002ZM7.18016 3.16683C6.38903 3.16683 5.61567 3.40142 4.95788 3.84095C4.30008 4.28047 3.78739 4.90519 3.48464 5.63609C3.18189 6.367 3.10268 7.17126 3.25702 7.94719C3.41136 8.72311 3.79232 9.43584 4.35173 9.99525C4.91114 10.5547 5.62387 10.9356 6.3998 11.09C7.17572 11.2443 7.97999 11.1651 8.71089 10.8623C9.4418 10.5596 10.0665 10.0469 10.506 9.38911C10.9456 8.73131 11.1802 7.95795 11.1802 7.16683C11.1802 6.10596 10.7587 5.08854 10.0086 4.3384C9.25844 3.58825 8.24102 3.16683 7.18016 3.16683Z"
                    fill="#667185"
                  />
                  <path
                    d="M13.3327 13.8336C13.267 13.8339 13.2019 13.8211 13.1412 13.7959C13.0805 13.7708 13.0255 13.7337 12.9793 13.687L10.226 10.9336C10.1377 10.8389 10.0896 10.7135 10.0919 10.584C10.0942 10.4544 10.1466 10.3308 10.2382 10.2392C10.3299 10.1476 10.4534 10.0951 10.583 10.0929C10.7125 10.0906 10.8379 10.1386 10.9327 10.227L13.686 12.9803C13.7796 13.0741 13.8322 13.2011 13.8322 13.3336C13.8322 13.4661 13.7796 13.5932 13.686 13.687C13.6398 13.7337 13.5848 13.7708 13.5241 13.7959C13.4634 13.8211 13.3984 13.8339 13.3327 13.8336Z"
                    fill="#667185"
                  />
                </svg>

                <input type="text" placeholder="Search year" />
              </div> */}

              <div className="ndclist-modal__list">


                  
                  {years?.map((item) => 
                  <div className="ndclist-modal__list__flex">
                   {currentYear !== item && <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
onClick={() => setCurrentYear(item)}
>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18043)" stroke-width="1.33333"/>
<defs>
<linearGradient id="paint0_linear_2889_18043" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>}

{currentYear === item && <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
onClick={() => setCurrentYear(new Date().getFullYear())}
>
<rect x="1" y="1" width="16" height="16" rx="4" stroke="url(#paint0_linear_2889_18037)" stroke-width="1.33333"/>
<path d="M5.5 9.49992L7.83333 11.8333L12.5 6.83325" stroke="url(#paint1_linear_2889_18037)" stroke-linecap="round" stroke-linejoin="round"/>
<defs>
<linearGradient id="paint0_linear_2889_18037" x1="1" y1="1.36719" x2="20.0689" y2="10.7886" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
<linearGradient id="paint1_linear_2889_18037" x1="5.5" y1="6.948" x2="12.5203" y2="11.8039" gradientUnits="userSpaceOnUse">
<stop stop-color="#006633"/>
<stop offset="1" stop-color="#02A4CC"/>
</linearGradient>
</defs>
</svg>}

                   
                    <div>{item}</div>
                  </div>
                )}
              </div>

           
            </div>
            }
            </button>
           
          </div>
        </div>

        {renderCalendarGrid()}

        <div className="scheduling-main__table">
          <div className="scheduling-main__table__header">
            <div>
              <button
                className={scheduleType === "pending" && "active"}
                onClick={() => setScheduleType("pending")}
              >
                Pending request
              </button>
              {!scheduleType && <div></div>}
              <button
                className={scheduleType === "installed" && "active"}
                onClick={() => setScheduleType("installed")}
              >
                Installation completed
              </button>
            </div>
            <div></div>
            {/* <div>
              <button
                // className={!scheduleType && "active"}
                onClick={() => setFilter(!filter)}
              >
                Filter by{" "}
                {!filter && <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.66536 6.49967L7.9987 9.83301L11.332 6.49967"
                    stroke="#98A2B3"
                    stroke-width="1.33333"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>}
               {filter && <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.66536 9.33303L7.9987 5.99969L11.332 9.33303" stroke="#98A2B3" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>}

              </button>
              {filter && <div>
                <div>Today</div>
                <div>Last 7 days</div>
                <div>January</div>
                <div>February</div>
                <div>March</div>
                <div>April</div>
                <div>May</div>
                <div>June</div>
                <div>July</div>
                <div>August</div>
                <div>September</div>
                <div>October</div>
                <div>November</div>
                <div>December</div>
              </div>}
            </div> */}
          </div>

          <div className="scheduling-main__table__label">
            <div>Company Name</div>
            <div>Location</div>
            <div>Date</div>
            <div>Status</div>
          </div>
          {scheduleType === "pending" && pendingActiveRequests?.map((item) => (
            <div
            className="scheduling-main__table__item"
            // onClick={() => navigate(`/admin/users/${user?.id}`)}
          >
            <div>{item?.detail?.companyName}</div>
            <div>{item?.detail?.companyLocation}</div>
            <div>{item?.value}</div>
            <button className="scheduling-main__table__item__active"
            onClick={() => handleSetCompleted(item)}
            >
              {activeLoading && selectedItem === item?.id ? "Loading..." : "Active"}
              {activeLoading && selectedItem === item?.id ? <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.625 1.59375H7.75C7.57595 1.59375 7.40903 1.66289 7.28596 1.78596C7.16289 1.90903 7.09375 2.07595 7.09375 2.25V9.75C7.09375 9.92405 7.16289 10.091 7.28596 10.214C7.40903 10.3371 7.57595 10.4062 7.75 10.4062H9.625C9.79905 10.4062 9.96597 10.3371 10.089 10.214C10.2121 10.091 10.2812 9.92405 10.2812 9.75V2.25C10.2812 2.07595 10.2121 1.90903 10.089 1.78596C9.96597 1.66289 9.79905 1.59375 9.625 1.59375ZM9.71875 9.75C9.71875 9.77486 9.70887 9.79871 9.69129 9.81629C9.67371 9.83387 9.64986 9.84375 9.625 9.84375H7.75C7.72514 9.84375 7.70129 9.83387 7.68371 9.81629C7.66613 9.79871 7.65625 9.77486 7.65625 9.75V2.25C7.65625 2.22514 7.66613 2.20129 7.68371 2.18371C7.70129 2.16613 7.72514 2.15625 7.75 2.15625H9.625C9.64986 2.15625 9.67371 2.16613 9.69129 2.18371C9.70887 2.20129 9.71875 2.22514 9.71875 2.25V9.75ZM4.75 1.59375H2.875C2.70095 1.59375 2.53403 1.66289 2.41096 1.78596C2.28789 1.90903 2.21875 2.07595 2.21875 2.25V9.75C2.21875 9.92405 2.28789 10.091 2.41096 10.214C2.53403 10.3371 2.70095 10.4062 2.875 10.4062H4.75C4.92405 10.4062 5.09097 10.3371 5.21404 10.214C5.33711 10.091 5.40625 9.92405 5.40625 9.75V2.25C5.40625 2.07595 5.33711 1.90903 5.21404 1.78596C5.09097 1.66289 4.92405 1.59375 4.75 1.59375ZM4.84375 9.75C4.84375 9.77486 4.83387 9.79871 4.81629 9.81629C4.79871 9.83387 4.77486 9.84375 4.75 9.84375H2.875C2.85014 9.84375 2.82629 9.83387 2.80871 9.81629C2.79113 9.79871 2.78125 9.77486 2.78125 9.75V2.25C2.78125 2.22514 2.79113 2.20129 2.80871 2.18371C2.82629 2.16613 2.85014 2.15625 2.875 2.15625H4.75C4.77486 2.15625 4.79871 2.16613 4.81629 2.18371C4.83387 2.20129 4.84375 2.22514 4.84375 2.25V9.75Z"
                  fill="#2A633D"
                />
              </svg> : ""}
            </button>
            {/* <button className="scheduling-main__table__item__pause">
              <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.869 1.52202C3.076 1.09102 2.125 1.66002 2.125 2.51652V9.48352C2.125 10.3405 3.076 10.909 3.869 10.478L10.275 6.99452C11.075 6.55952 11.075 5.44052 10.275 5.00602L3.869 1.52202ZM1.375 2.51652C1.375 1.06402 2.9585 0.17302 4.2275 0.86352L10.6335 4.34702C11.9555 5.06602 11.9555 6.93402 10.6335 7.65302L4.2275 11.1365C2.9585 11.8265 1.375 10.9365 1.375 9.48352V2.51652Z"
                  fill="#E4E7EC"
                />
              </svg>
              Pause
            </button> */}
            {/* <button className="scheduling-main__table__item__completed">
              Completed
              <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2770_2768)">
                  <path
                    d="M8.98633 3.48633L9.51367 4.01367L5.125 8.40234L2.98633 6.26367L3.51367 5.73633L5.125 7.34766L8.98633 3.48633ZM6.25 0C6.80078 0 7.33203 0.0703125 7.84375 0.210938C8.35547 0.351562 8.83398 0.552734 9.2793 0.814453C9.72461 1.07617 10.1289 1.38867 10.4922 1.75195C10.8555 2.11523 11.168 2.52148 11.4297 2.9707C11.6914 3.41992 11.8926 3.89844 12.0332 4.40625C12.1738 4.91406 12.2461 5.44531 12.25 6C12.25 6.55078 12.1797 7.08203 12.0391 7.59375C11.8984 8.10547 11.6973 8.58398 11.4355 9.0293C11.1738 9.47461 10.8613 9.87891 10.498 10.2422C10.1348 10.6055 9.72852 10.918 9.2793 11.1797C8.83008 11.4414 8.35156 11.6426 7.84375 11.7832C7.33594 11.9238 6.80469 11.9961 6.25 12C5.69922 12 5.16797 11.9297 4.65625 11.7891C4.14453 11.6484 3.66602 11.4473 3.2207 11.1855C2.77539 10.9238 2.37109 10.6113 2.00781 10.248C1.64453 9.88477 1.33203 9.47852 1.07031 9.0293C0.808594 8.58008 0.607422 8.10352 0.466797 7.59961C0.326172 7.0957 0.253906 6.5625 0.25 6C0.25 5.44922 0.320312 4.91797 0.460938 4.40625C0.601562 3.89453 0.802734 3.41602 1.06445 2.9707C1.32617 2.52539 1.63867 2.12109 2.00195 1.75781C2.36523 1.39453 2.77148 1.08203 3.2207 0.820312C3.66992 0.558594 4.14648 0.357422 4.65039 0.216797C5.1543 0.0761719 5.6875 0.00390625 6.25 0ZM6.25 11.25C6.73047 11.25 7.19336 11.1875 7.63867 11.0625C8.08398 10.9375 8.50195 10.7617 8.89258 10.5352C9.2832 10.3086 9.63867 10.0332 9.95898 9.70898C10.2793 9.38477 10.5527 9.03125 10.7793 8.64844C11.0059 8.26562 11.1836 7.84766 11.3125 7.39453C11.4414 6.94141 11.5039 6.47656 11.5 6C11.5 5.51953 11.4375 5.05664 11.3125 4.61133C11.1875 4.16602 11.0117 3.74805 10.7852 3.35742C10.5586 2.9668 10.2832 2.61133 9.95898 2.29102C9.63477 1.9707 9.28125 1.69727 8.89844 1.4707C8.51562 1.24414 8.09766 1.06641 7.64453 0.9375C7.19141 0.808594 6.72656 0.746094 6.25 0.75C5.76953 0.75 5.30664 0.8125 4.86133 0.9375C4.41602 1.0625 3.99805 1.23828 3.60742 1.46484C3.2168 1.69141 2.86133 1.9668 2.54102 2.29102C2.2207 2.61523 1.94727 2.96875 1.7207 3.35156C1.49414 3.73438 1.31641 4.15234 1.1875 4.60547C1.05859 5.05859 0.996094 5.52344 1 6C1 6.48047 1.0625 6.94336 1.1875 7.38867C1.3125 7.83398 1.48828 8.25195 1.71484 8.64258C1.94141 9.0332 2.2168 9.38867 2.54102 9.70898C2.86523 10.0293 3.21875 10.3027 3.60156 10.5293C3.98438 10.7559 4.40234 10.9336 4.85547 11.0625C5.30859 11.1914 5.77344 11.2539 6.25 11.25Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2770_2768">
                    <rect
                      width="12"
                      height="12"
                      fill="white"
                      transform="translate(0.25)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button> */}
          </div>
          ))}
          {scheduleType === "pending" && pendingInactiveRequests?.map((item) => (
            <div
            className="scheduling-main__table__item"
            // onClick={() => navigate(`/admin/users/${user?.id}`)}
          >
            <div>{item?.detail?.companyName}</div>
            <div>{item?.detail?.companyLocation}</div>
            <div>{item?.value}</div>
            
            <button className="scheduling-main__table__item__pause"
            onClick={() => handleSetOngoing(item)}
            >
              {ongoingLoading && selectedItem === item?.id ? <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.869 1.52202C3.076 1.09102 2.125 1.66002 2.125 2.51652V9.48352C2.125 10.3405 3.076 10.909 3.869 10.478L10.275 6.99452C11.075 6.55952 11.075 5.44052 10.275 5.00602L3.869 1.52202ZM1.375 2.51652C1.375 1.06402 2.9585 0.17302 4.2275 0.86352L10.6335 4.34702C11.9555 5.06602 11.9555 6.93402 10.6335 7.65302L4.2275 11.1365C2.9585 11.8265 1.375 10.9365 1.375 9.48352V2.51652Z"
                  fill="#E4E7EC"
                />
              </svg> : ""}
              {ongoingLoading && selectedItem === item?.id ? "Loading..." : "Pause"}
            </button>
            {/* <button className="scheduling-main__table__item__completed">
              Completed
              <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2770_2768)">
                  <path
                    d="M8.98633 3.48633L9.51367 4.01367L5.125 8.40234L2.98633 6.26367L3.51367 5.73633L5.125 7.34766L8.98633 3.48633ZM6.25 0C6.80078 0 7.33203 0.0703125 7.84375 0.210938C8.35547 0.351562 8.83398 0.552734 9.2793 0.814453C9.72461 1.07617 10.1289 1.38867 10.4922 1.75195C10.8555 2.11523 11.168 2.52148 11.4297 2.9707C11.6914 3.41992 11.8926 3.89844 12.0332 4.40625C12.1738 4.91406 12.2461 5.44531 12.25 6C12.25 6.55078 12.1797 7.08203 12.0391 7.59375C11.8984 8.10547 11.6973 8.58398 11.4355 9.0293C11.1738 9.47461 10.8613 9.87891 10.498 10.2422C10.1348 10.6055 9.72852 10.918 9.2793 11.1797C8.83008 11.4414 8.35156 11.6426 7.84375 11.7832C7.33594 11.9238 6.80469 11.9961 6.25 12C5.69922 12 5.16797 11.9297 4.65625 11.7891C4.14453 11.6484 3.66602 11.4473 3.2207 11.1855C2.77539 10.9238 2.37109 10.6113 2.00781 10.248C1.64453 9.88477 1.33203 9.47852 1.07031 9.0293C0.808594 8.58008 0.607422 8.10352 0.466797 7.59961C0.326172 7.0957 0.253906 6.5625 0.25 6C0.25 5.44922 0.320312 4.91797 0.460938 4.40625C0.601562 3.89453 0.802734 3.41602 1.06445 2.9707C1.32617 2.52539 1.63867 2.12109 2.00195 1.75781C2.36523 1.39453 2.77148 1.08203 3.2207 0.820312C3.66992 0.558594 4.14648 0.357422 4.65039 0.216797C5.1543 0.0761719 5.6875 0.00390625 6.25 0ZM6.25 11.25C6.73047 11.25 7.19336 11.1875 7.63867 11.0625C8.08398 10.9375 8.50195 10.7617 8.89258 10.5352C9.2832 10.3086 9.63867 10.0332 9.95898 9.70898C10.2793 9.38477 10.5527 9.03125 10.7793 8.64844C11.0059 8.26562 11.1836 7.84766 11.3125 7.39453C11.4414 6.94141 11.5039 6.47656 11.5 6C11.5 5.51953 11.4375 5.05664 11.3125 4.61133C11.1875 4.16602 11.0117 3.74805 10.7852 3.35742C10.5586 2.9668 10.2832 2.61133 9.95898 2.29102C9.63477 1.9707 9.28125 1.69727 8.89844 1.4707C8.51562 1.24414 8.09766 1.06641 7.64453 0.9375C7.19141 0.808594 6.72656 0.746094 6.25 0.75C5.76953 0.75 5.30664 0.8125 4.86133 0.9375C4.41602 1.0625 3.99805 1.23828 3.60742 1.46484C3.2168 1.69141 2.86133 1.9668 2.54102 2.29102C2.2207 2.61523 1.94727 2.96875 1.7207 3.35156C1.49414 3.73438 1.31641 4.15234 1.1875 4.60547C1.05859 5.05859 0.996094 5.52344 1 6C1 6.48047 1.0625 6.94336 1.1875 7.38867C1.3125 7.83398 1.48828 8.25195 1.71484 8.64258C1.94141 9.0332 2.2168 9.38867 2.54102 9.70898C2.86523 10.0293 3.21875 10.3027 3.60156 10.5293C3.98438 10.7559 4.40234 10.9336 4.85547 11.0625C5.30859 11.1914 5.77344 11.2539 6.25 11.25Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2770_2768">
                    <rect
                      width="12"
                      height="12"
                      fill="white"
                      transform="translate(0.25)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button> */}
          </div>
          ))}
          {scheduleType === "installed" && completedRequests?.map((item) => (
            <div
            className="scheduling-main__table__item"
            // onClick={() => navigate(`/admin/users/${user?.id}`)}
          >
            <div>{item?.detail?.companyName}</div>
            <div>{item?.detail?.companyLocation}</div>
            <div>{item?.value}</div>
            
         
            <button className="scheduling-main__table__item__completed">
              Completed
              <svg
                width="13"
                height="12"
                viewBox="0 0 13 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2770_2768)">
                  <path
                    d="M8.98633 3.48633L9.51367 4.01367L5.125 8.40234L2.98633 6.26367L3.51367 5.73633L5.125 7.34766L8.98633 3.48633ZM6.25 0C6.80078 0 7.33203 0.0703125 7.84375 0.210938C8.35547 0.351562 8.83398 0.552734 9.2793 0.814453C9.72461 1.07617 10.1289 1.38867 10.4922 1.75195C10.8555 2.11523 11.168 2.52148 11.4297 2.9707C11.6914 3.41992 11.8926 3.89844 12.0332 4.40625C12.1738 4.91406 12.2461 5.44531 12.25 6C12.25 6.55078 12.1797 7.08203 12.0391 7.59375C11.8984 8.10547 11.6973 8.58398 11.4355 9.0293C11.1738 9.47461 10.8613 9.87891 10.498 10.2422C10.1348 10.6055 9.72852 10.918 9.2793 11.1797C8.83008 11.4414 8.35156 11.6426 7.84375 11.7832C7.33594 11.9238 6.80469 11.9961 6.25 12C5.69922 12 5.16797 11.9297 4.65625 11.7891C4.14453 11.6484 3.66602 11.4473 3.2207 11.1855C2.77539 10.9238 2.37109 10.6113 2.00781 10.248C1.64453 9.88477 1.33203 9.47852 1.07031 9.0293C0.808594 8.58008 0.607422 8.10352 0.466797 7.59961C0.326172 7.0957 0.253906 6.5625 0.25 6C0.25 5.44922 0.320312 4.91797 0.460938 4.40625C0.601562 3.89453 0.802734 3.41602 1.06445 2.9707C1.32617 2.52539 1.63867 2.12109 2.00195 1.75781C2.36523 1.39453 2.77148 1.08203 3.2207 0.820312C3.66992 0.558594 4.14648 0.357422 4.65039 0.216797C5.1543 0.0761719 5.6875 0.00390625 6.25 0ZM6.25 11.25C6.73047 11.25 7.19336 11.1875 7.63867 11.0625C8.08398 10.9375 8.50195 10.7617 8.89258 10.5352C9.2832 10.3086 9.63867 10.0332 9.95898 9.70898C10.2793 9.38477 10.5527 9.03125 10.7793 8.64844C11.0059 8.26562 11.1836 7.84766 11.3125 7.39453C11.4414 6.94141 11.5039 6.47656 11.5 6C11.5 5.51953 11.4375 5.05664 11.3125 4.61133C11.1875 4.16602 11.0117 3.74805 10.7852 3.35742C10.5586 2.9668 10.2832 2.61133 9.95898 2.29102C9.63477 1.9707 9.28125 1.69727 8.89844 1.4707C8.51562 1.24414 8.09766 1.06641 7.64453 0.9375C7.19141 0.808594 6.72656 0.746094 6.25 0.75C5.76953 0.75 5.30664 0.8125 4.86133 0.9375C4.41602 1.0625 3.99805 1.23828 3.60742 1.46484C3.2168 1.69141 2.86133 1.9668 2.54102 2.29102C2.2207 2.61523 1.94727 2.96875 1.7207 3.35156C1.49414 3.73438 1.31641 4.15234 1.1875 4.60547C1.05859 5.05859 0.996094 5.52344 1 6C1 6.48047 1.0625 6.94336 1.1875 7.38867C1.3125 7.83398 1.48828 8.25195 1.71484 8.64258C1.94141 9.0332 2.2168 9.38867 2.54102 9.70898C2.86523 10.0293 3.21875 10.3027 3.60156 10.5293C3.98438 10.7559 4.40234 10.9336 4.85547 11.0625C5.30859 11.1914 5.77344 11.2539 6.25 11.25Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2770_2768">
                    <rect
                      width="12"
                      height="12"
                      fill="white"
                      transform="translate(0.25)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
          ))}
        </div>
      </div>
    </div>
  );
}
